import { render, staticRenderFns } from "./NumpadExpanded.vue?vue&type=template&id=63db910e&"
import script from "./NumpadExpanded.vue?vue&type=script&lang=js&"
export * from "./NumpadExpanded.vue?vue&type=script&lang=js&"
import style0 from "./NumpadExpanded.vue?vue&type=style&index=0&id=63db910e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports